// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// @ts-ignore
import packageInfo from '../../package.json';

export const environment = {
  production: false,
  version: packageInfo.version,
  firebase: {
    apiKey: 'AIzaSyCXg7lSSxoP3YW6_6syqq5kfViaBCTN1Cc',
    authDomain: 'bbefrance-db063.firebaseapp.com',
    databaseURL: 'https://bbefrance-db063.firebaseio.com',
    projectId: 'bbefrance-db063',
    storageBucket: 'bbefrance-db063.appspot.com',
    messagingSenderId: '812867934703',
    appId: '1:812867934703:web:534af69fa2eb903ab7be1a'
}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
